export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img 
          src="https://public.readdy.ai/ai/img_res/5383e40683d3c2c66aab7bfb4b1f153d.jpg" 
          alt="Espacio de terapia profesional" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 font-['Playfair_Display'] leading-tight">
          Transforma Tu Vida con Apoyo Profesional
        </h2>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Especializada en terapia individual, terapia de pareja y bienestar emocional. 
          Un espacio seguro para tu crecimiento personal y sanación.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a 
            href="https://wa.me/526692612777?text=Hola%2C%20me%20gustaría%20agendar%20una%20consulta" 
            target="_blank" 
            rel="noopener noreferrer"
            className="bg-[#14B8A6] text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-[#0F9688] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Agenda Tu Consulta Ahora
          </a>
          <a 
            href="#servicios"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
          >
            Conoce Mis Servicios
          </a>
        </div>
        
        {/* Stats */}
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-8 max-w-3xl mx-auto">
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">30+</div>
            <div className="text-white/90 text-sm">Años de Experiencia</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">900+</div>
            <div className="text-white/90 text-sm">Pacientes Atendidos</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-white mb-2">100%</div>
            <div className="text-white/90 text-sm">Satisfacción</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white"></i>
      </div>
    </section>
  );
}